import { inject } from '@angular/core';
import { EcApiService } from '@shared/services';
import { PERMISSIONS } from '@shared/constants';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const ecTableConfig = (): TableConfig => {
  const ecApiService = inject(EcApiService);

  return {
    title: 'Danh sách EC',
    entityName: 'EC',
    service: ecApiService,
    method: 'getEcs',
    columns: [
      { field: 'employee.code', header: 'Mã NV', width: 'min-w-[80px]', sortable: true, type: 'text'},
      { field: 'profile.fullname', header: 'Họ tên', width: 'min-w-[180px]', sortable: true, type: 'text'},
      { field: 'profile.nickname', header: 'Nickname', width: 'min-w-[150px]', sortable: true, type: 'text'},
      { field: 'employeePosition.status', header: 'Tình trạng', width: 'min-w-[150px]', sortable: true, type: 'tag', tagType: 'employeePositionStatus' },
      { field: 'note', header: 'Ghi chú', width: 'min-w-[200px]', sortable: false, type: 'text' }
    ],
    features: {
      virtualScroll: true,
      toolbar: true
    },
    actions: [
      {
        location: 'row',
        useDefaultStyle: 'edit',
        permission: PERMISSIONS.EC_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      }
    ]
  };
};

